import React from 'react';
import {Layout, Icon, Badge, Spacer} from '@di-nxt/components';

type Props = {
  badgeNumber: number;
  onPress: () => void;
};
export const UnassignedButton: React.FC<Props> = ({badgeNumber, onPress}) => {
  return (
    <Layout
      padding="4"
      borderRadius="4"
      align="center"
      backgroundColor="transparent"
      hover
      onPress={onPress}>
      {badgeNumber !== 0 && (
        <>
          <Spacer width="4" />
          <Badge
            content={badgeNumber.toString()}
            kind="Negative"
            round={false}
            size="Small"
          />
          <Spacer width="4" />
        </>
      )}
      <Icon name="drawer" size="24" />
    </Layout>
  );
};
